import React from "react";
import { Route, Routes } from "react-router-dom";

import { VenueContext } from "../../VenueContext";
import DrinkInMenu from "../DrinkInMenu";
import Gallery from "../Gallery";
import Header from "../Header";
import VenueHome from "../VenueHome";
import WhatsOn from "../WhatsOn";

const SECTIONS = [
  { label: "Home", to: "/eltham" },
  { label: "Drinks", to: "/eltham/drinks" },
  { label: "What’s On", to: "/eltham/whats-on" },
  { label: "Gallery", to: "/eltham/gallery" },
];

const Eltham = () => {
  return (
    <VenueContext.Provider value="Eltham">
      <Header sections={SECTIONS} />
      <Routes>
        <Route path="/" element={<VenueHome location="eltham" />} />
        <Route path="/drinks/*" element={<DrinkInMenu />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/whats-on" element={<WhatsOn />} />
      </Routes>
    </VenueContext.Provider>
  );
};

export default Eltham;
